import { Component, Inject } from '@angular/core';
import { Transaction } from '@contracts/interfaces/transaction.interfaces';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerService } from '../../services/customer.service';

export interface DialogData {
  category: string;
}

@Component({
  selector: 'app-item-search-dialog',
  templateUrl: 'customer-import.dialog.html',
  styleUrls: ['./customer-import.dialog.scss']
})
export class CustomerImportDialogComponent {

  private fileReader = new FileReader();

  sources = [
    {
      "name": "Google Contacts",
      "value": "google-contacts"
    },
    {
      "name": "Wave Contacts",
      "value": "wave-contacts"
    }
  ]


  ignoreOption: string = "";

  selectedCategory: string = "";
  selectedSource: string = "bankofmelbourne";

  found = 0;
  notDups = 0;

  step = 'select-source';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public customerService: CustomerService) {
      this.selectedCategory = data.category;
    }

  fileChanged(evt) {
    this.fileReader.readAsText(evt.target.files[0]);
  }

  files: File[] = [];

  onSelect(event) {

    if (event.addedFiles.length > 0) {
      const reader = new FileReader();

      console.log(event.addedFiles);

      reader.onload = (e) => {
        const contents = e.target.result;
        console.log();
        this.customerService.import(this.selectedSource, contents).subscribe(r => {
          console.log(r);
          this.dialog.closeAll();
        });
      };

      reader.readAsText(event.addedFiles[0]);
    }

  }

  public open(callback: any) {
      let dialog = this.dialog.open(CustomerImportDialogComponent, {
          width: '800px',
          data: {}
      });

      dialog.afterClosed().subscribe(r => {
          callback();
      })
  }




}
